exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-danger{border:1px solid #f56c6c;border-radius:2px}.blank-question{position:relative}", ""]);

// exports
